<template>
  <div>
    <div>
      <h2 class="font-bold text-xl mb-6">Push Notification</h2>

      <TextEditor />
    </div>
  </div>
</template>

<script>
import TextEditor from "./TextEditor.vue";
export default {
  data() {
    return {};
  },
  components: {
    TextEditor
  }
};
</script>
